// packages
const { h, Component } = require("preact");

// components
import ByCategoryTitle from './ByCategoryTitle';
import ByCategoryBar from './ByCategoryBar';
import BarLegend from './BarLegend'
import Annotation from './Annotation';

// internal

class ByCategoryRow extends Component {
  constructor() {
    super();

    this.state = {}
  }
  
  render() {   
    console.log(this.props.data)
    return (
      <div>
        <div class="bar-legend">
          <BarLegend />
        </div>
        <div class="by-category">
          {this.props.data.map(d => (
            <div>
              <div class="bar-row-top">
                <div class="group-name">{d.title}</div>
                <div class="counties">{d.description}</div>
              </div>
              <div class="bar-row-bottom">
                <ByCategoryTitle
                  category={d.category}
                  mapData={this.props.mapData}
                  tag={d.category}
                />
                <ByCategoryBar
                  data={d}
                  category={d.category}
                  desc={d.description}
                />
                {/* <Annotation
                  regVoters={d.registered_2024}
                  category={d.category}
                /> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default ByCategoryRow;